import axios from 'axios';

export const fetchToeOptions = async () => {
  const res = await axios.get('/casegpt/toe/options');
  return res.data;
};

export const fetchMoConversationByDbq = async (userDbqId) => {
  if (!userDbqId) return { conversation: null, messages: [] };
  const res = await axios.get(`/casegpt/mo/conversations/${userDbqId}`);
  return res.data;
};

export const createMoConversation = async (userDbqId) => {
  const res = await axios.post('/casegpt/mo/conversations', { userDbqId });
  return res.data;
};

export const deleteMoConversation = async (moConversationId) => {
  const res = await axios.delete(`/casegpt/mo/conversations/${moConversationId}`);
  return res.data;
};

export const setUserDbqToe = async (userDbqId, toeId) => {
  const res = await axios.put(`/casegpt/user-dbq/${userDbqId}/toe`, { toeId });
  return res.data;
};

export const approveMoConversation = async (moConversationId, finalMedicalOpinion) => {
  const res = await axios.put(
    `/casegpt/mo/conversations/${moConversationId}/approve`,
    { finalMedicalOpinion },
  );
  return res.data;
};

export const applyMoConversationToDbq = async (
  moConversationId,
  finalMedicalOpinion,
) => {
  const res = await axios.put(
    `/casegpt/mo/conversations/${moConversationId}/apply-to-dbq`,
    { finalMedicalOpinion },
  );
  return res.data;
};

export const saveMoRemarksFullText = async (userDbqId, fullMedicalOpinionText) => {
  const res = await axios.put(`/casegpt/mo/remarks/${userDbqId}`, {
    fullMedicalOpinionText,
  });
  return res.data;
};

/**
 * Search for relevant pages within specific files using vector search
 * @param {string} claimId - The claim ID
 * @param {string[]} fileIds - Array of file IDs to search within
 * @param {string} searchQuery - The search query
 * @returns {Promise<{pages: Array}>} Matching pages with scores
 */
export const searchPagesInFiles = async (claimId, fileIds, searchQuery) => {
  const res = await axios.post('/casegpt/mo/search-pages', {
    claimId,
    fileIds,
    searchQuery,
    topK: 50,           // Get more results
    scoreThreshold: 0.15, // Very permissive - let user decide what's relevant
  });
  return res.data;
};
